import { Lucky7Page } from "../lucky7";

// casino/lucky7eu2 ("Lucky 7 - C") — same reference page as Lucky 7 (the API type comes from the route)
export default function Lucky7C() {
  return <Lucky7Page defaultType="lucky7eu2" />;
}
